import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, message } from 'antd'
import { deleteBackstageUser } from '../../actions/admin'
import http from '../../utils/api'

const DeleteBackstageUserModal = ({
  visible,
  userName,
  userId,
  handleOk,
  handleCancel,
}) => {
  const [loading, setLoading] = useState(false)

  const deleteUser = () => {
    setLoading(true)
    deleteBackstageUser(userId)
      .then(() => {
        message.open({
          content: 'User deleted successfully',
          icon: (
            <FontAwesomeIcon
              icon={faTrashAlt}
              style={{ marginRight: '10px', color: '#D62B34' }}
            />
          ),
        })
        handleOk()
      })
      .catch((error) => {
        message.error('An error occurred')
        handleOk()
      })
      .finally(() => {
        setLoading(false)
        handleOk()
      })
  }

  return (
    <Modal
      className="cc-modal-accept"
      title={`Delete User`}
      visible={visible}
      okText={`Delete User`}
      cancelText="Cancel"
      onOk={deleteUser}
      onCancel={handleCancel}
      okButtonProps={{
        disabled: loading,
        style: { backgroundColor: '#D62B34', borderStyle: 'none' },
      }}
      centered={true}
      cancelButtonProps={{ disabled: false }}
    >
      <div>
        Are you sure you want to delete <strong>{userName}</strong> from the
        platform?
      </div>
    </Modal>
  )
}

DeleteBackstageUserModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  userName: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
}

export default DeleteBackstageUserModal
